var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgController(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 19.75C19.5 17.2891 21.5039 15.25 24 15.25C26.4609 15.25 28.5 17.2891 28.5 19.75C28.5 22.2461 26.4609 24.25 24 24.25C21.5039 24.25 19.5 22.2461 19.5 19.75ZM26.8125 19.75C26.8125 18.2031 25.5469 16.9375 24 16.9375C22.418 16.9375 21.1875 18.2031 21.1875 19.75C21.1875 21.332 22.418 22.5625 24 22.5625C25.5469 22.5625 26.8125 21.332 26.8125 19.75ZM23.4727 27.9062L22.3125 25.9375H25.6875L24.4922 27.9062L25.0547 29.9805L26.7773 26.5352C29.625 26.8516 31.875 29.2422 31.875 32.1953C31.875 32.793 31.3828 33.25 30.7852 33.25H17.1797C16.582 33.25 16.125 32.793 16.125 32.1953C16.125 29.2422 18.3398 26.8516 21.1875 26.5352L22.9102 29.9805L23.4727 27.9062ZM27.6914 28.5039L26.1445 31.5625H30.1172C29.9062 30.1914 28.957 29.0312 27.6914 28.5039ZM17.8477 31.5625H21.8203L20.2734 28.5039C19.0078 29.0312 18.0586 30.1914 17.8477 31.5625Z",
    fill: "#404252"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgController);
export default __webpack_public_path__ + "static/media/controller.9f36a9104fdfce481ba93a5961574971.svg";
export { ForwardRef as ReactComponent };